<template>
<div id="app">
  <router-view></router-view>
</div>
</template>

<script>
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/build/css/mdb.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './common.css'
import 'c3/c3.min.css'
import 'bulma/css/bulma.css'
import './assets/font-awesome-4.7.0/css/font-awesome.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vuetify/dist/vuetify.min.css'
export default {
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    getOffset (el) {
      var _x = 0
      var _y = 0
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft
        _y += el.offsetTop - el.scrollTop
        el = el.offsetParent
      }
      return { top: _y, left: _x }
    },
    scrollToTop () {
      var topPageElements = this.$el.getElementsByClassName('top-page')
      var numberTopElements = topPageElements.length
      if (numberTopElements > 0) {
        var lastTopPageElement = topPageElements[numberTopElements - 1]
        var elementPosition = this.getOffset(lastTopPageElement)
        var currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        window.scrollTo(elementPosition['left'], Math.min(currentPosition, elementPosition['top'] - 75))
      }
    }
  },
  watch: {
    $route (to, from) {
      this.scrollToTop()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?009fc7d0